<template>
  <div class="top-nav">
    <el-dropdown>
      <span class="el-dropdown-link">
        <!--          <i class="el-icon-user-solid"></i>-->
        <el-avatar :size="20" :src="circleUrl" style="float: left;margin-right: 10px"></el-avatar> {{ accountName }}<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="(item, index) in dropdownList" :key="index" @click.native="goPath(item.name, item.type)">{{ item.name }} </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import store from '@/store/index'
import { getRoleById, useCurrentUser, logout } from '@/api/crm'
export default {
  name: 'top-nav',
  data () {
    return {
      circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
      dropdownList: [{
        name: '我的账号信息',
        type: 0
      }, {
        name: '退出登录',
        type: 1
      }],
      accountName: '',
      type: window.localStorage.getItem('key')
    }
  },
  created () {
    this.$store.commit('awsSdk/RESET')
    this.getRole()
  },
  methods: {
    getRole () {
      useCurrentUser(this.type).then((res) => {
        if (res.data.success) {
          this.accountName = res.data.data.fullName
          this.$store.commit('user/changeUserType', res.data.data.userType)
          this.$store.commit('user/userServiceMsg', res.data.data.customerInfo)
        } else {
        }
      })
    },
    goPath (name, type) {
      if (type === 0) {
        if (this.$route.path !== '/myaccountinfo') {
          this.$router.push('./myaccountinfo')
          window.localStorage.setItem('activePath', './')
        }
      }
      if (type === 1) {
        logout().then(res => {
          // if (res.data.success) {
          localStorage.removeItem('userId')
          localStorage.removeItem('token')
          localStorage.removeItem('accessTokenExpiry')
          localStorage.removeItem('refresh_token')
          localStorage.removeItem('refreshTokenExpiry')
          localStorage.removeItem('key')
          localStorage.removeItem('access_token')
          this.$store.commit('user/changeIsLogin', false)
          this.$router.push('/login')
          // }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.top-nav {
  display: flex;
  justify-content: flex-end;

  .el-dropdown {
    cursor: pointer;
    padding: 0 15px;

    &:hover {
      background: #f9f9f9;
    }
  }

  .el-icon-arrow-down {
    font-weight: bold;
    color: #666;
  }

  .el-icon-user-solid {
    font-size: 18px;
    color: #999;
  }

  .el-icon-switch-button {
    font-weight: bold;
    color: #999;
    font-size: 18px;
    margin-left: 30px;
    margin-right: 10px;
    cursor: pointer;
    line-height: 45px;
  }

  .el-dropdown-link {
    font-size: 12px;
    color: #2a2a2a;
    line-height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
